import React, {useEffect, useState} from "react";
import * as Icons from "../../components/buttons/IconButtons";
import CustomCard from "../../components/CustomCard";
import {useTranslation} from "react-i18next";
import CustomSearch from "../../components/SearchSimples/CustomSearch";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const IconLibrary = () => {
    const iconEntries = Object.entries(Icons);
    const { t } = useTranslation();
    const [search, setSearch] = useState("");
    const [results, setResults] = useState(iconEntries);

    useEffect(() => {
        if (search.trim() === "") {
            setResults(iconEntries);
        } else {
            const filtered = iconEntries.filter(([name, IconComponent]) =>
                name.toLowerCase().includes(search.toLowerCase())
            );
            setResults(filtered);
        }
    }, [search]);

    return (
        <>
            <h1 className={"ibl-font-w-600 my-3"}>🎨 {t("icon_library")}</h1>
            <div className={"row"}>
                <div className={'col-12'}>
                    <CustomSearch
                        id={"txt_il_search_icon"}
                        label={'type_something_to_search'}
                        value={search}
                        setValue={setSearch}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
            </div>
            <div className={"row"}>
                {results.map(([name, IconComponent]) => (
                    <div className={"col-sm-12 col-md-2 col-lg-2 col-xl-2 mb-2 text-center"}>
                        <CustomCard
                            classes={'card-shades-100 border-radius-8px'}
                            classContent={"p-0"}
                            children={
                                <>
                                    <div className={"d-flex justify-content-center"}>
                                        {/*Assets imported as a url (gif, png) are strings, only the svg ones are components*/}
                                        {typeof IconComponent === "string"
                                            ? <img src={IconComponent} alt={name} width={32} height={32}/>
                                            : <IconComponent width={32} height={32}/>}
                                    </div>
                                    <p>{name}</p>
                                </>
                            }
                        />
                    </div>
                ))}
            </div>
        </>
    );
};

export default IconLibrary;
